import { Trans } from "@lingui/macro";
import { testAppendAttr } from "@smp/utils";
import { useNavigate } from "react-router-dom";

import { HeaderButton } from "../../shared";

export const Free2022 = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/billing/plans");
  };

  return (
    <HeaderButton
      onClick={handleClick}
      textLeft={<Trans>Free</Trans>}
      {...testAppendAttr("id", "header_billing_free2022")}
    />
  );
};
